import { connect } from 'react-redux';
import AlbumsView from './index'
import {loadAlbums, removeAlbum, updateAlbum} from '../../actions/Albums'

const mapStateToProps = (state, props) => {
    
    return {
	albums: state.albums.list,
	authenticated: state.session.authenticated
    }
}

const mapDispatchToProps = (dispatch, state) => {
    return {
	loadAlbums: () => dispatch(loadAlbums()),
	removeAlbum: (id) => dispatch(removeAlbum(id)).then(() => dispatch(loadAlbums())),
	updateAlbum: (data) => dispatch(updateAlbum(data))
    }
}

const AlbumsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AlbumsView);




export default AlbumsContainer;



// WEBPACK FOOTER //
// ./src/components/Albums/Container.js